interface AgentConfigPanelProps {
  content: string;
}

function renderMarkdown(text: string): JSX.Element[] {
  const lines = text.split("\n");
  const elements: JSX.Element[] = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];

    if (line.startsWith("## ")) {
      elements.push(
        <h2 key={i} className="text-[13px] font-semibold text-[#1D2129] mt-4 mb-2 first:mt-0">
          {line.replace("## ", "")}
        </h2>
      );
    } else if (line.startsWith("### ")) {
      elements.push(
        <h3 key={i} className="text-[12px] font-semibold text-[#1D2129] mt-3 mb-1.5">
          {line.replace("### ", "")}
        </h3>
      );
    } else if (line.startsWith("---")) {
      elements.push(<hr key={i} className="border-[#E5E6EB] my-3" />);
    } else if (line.startsWith("- **")) {
      const match = line.match(/- \*\*(.+?)\*\*[：:](.*)/);
      if (match) {
        elements.push(
          <div key={i} className="flex gap-1.5 text-[12px] text-[#1D2129] leading-[1.6] mb-1 pl-2">
            <span className="text-[#646479] flex-shrink-0">•</span>
            <span><strong className="font-medium text-[#1D2129]">{match[1]}</strong>
              <span className="text-[#4E5969]">{match[2]}</span></span>
          </div>
        );
      } else {
        elements.push(
          <div key={i} className="flex gap-1.5 text-[12px] text-[#4E5969] leading-[1.6] mb-1 pl-2">
            <span className="text-[#646479] flex-shrink-0">•</span>
            <span>{line.replace(/^- \*\*?|\*\*?$/g, "")}</span>
          </div>
        );
      }
    } else if (line.startsWith("- ")) {
      elements.push(
        <div key={i} className="flex gap-1.5 text-[12px] text-[#4E5969] leading-[1.6] mb-1 pl-2">
          <span className="text-[#646479] flex-shrink-0">•</span>
          <span>{line.replace("- ", "")}</span>
        </div>
      );
    } else if (line.startsWith("**") && line.endsWith("**")) {
      elements.push(
        <p key={i} className="text-[12px] font-medium text-[#1D2129] mb-1">
          {line.replace(/\*\*/g, "")}
        </p>
      );
    } else if (line.trim() !== "") {
      const formatted = line
        .replace(/\*\*(.+?)\*\*/g, '<strong class="font-medium text-[#1D2129]">$1</strong>')
        .replace(/（(.+?)）/g, '<span class="text-[#646479]">（$1）</span>');
      elements.push(
        <p
          key={i}
          className="text-[12px] text-[#4E5969] leading-[1.7] mb-1"
          dangerouslySetInnerHTML={{ __html: formatted }}
        />
      );
    }
    i++;
  }
  return elements;
}

export default function AgentConfigPanel({ content }: AgentConfigPanelProps) {
  return (
    <div className="flex flex-col h-full bg-white">
      <div className="flex items-center justify-between px-4 h-11 border-b border-[#E5E6EB] flex-shrink-0">
        <span className="text-[13px] font-semibold text-[#1D2129]">Agent配置</span>
        <div className="flex items-center gap-1">
          <button className="w-7 h-7 flex items-center justify-center text-[#646479] hover:text-[#1D2129] hover:bg-[#F5F6F9] rounded-lg transition-colors cursor-pointer">
            <i className="ri-mail-line text-[13px]"></i>
          </button>
          <button className="w-7 h-7 flex items-center justify-center text-[#646479] hover:text-[#1D2129] hover:bg-[#F5F6F9] rounded-lg transition-colors cursor-pointer">
            <i className="ri-share-line text-[13px]"></i>
          </button>
          <button className="w-7 h-7 flex items-center justify-center text-[#646479] hover:text-[#1D2129] hover:bg-[#F5F6F9] rounded-lg transition-colors cursor-pointer">
            <i className="ri-more-2-line text-[13px]"></i>
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
        <div className="rounded-2xl border border-[#E5E6EB] bg-[#F9FAFB] px-3 py-3">
          <div className="text-[11px] font-medium text-[#8B8FA8] mb-2">配置内容</div>
          <div className="space-y-1.5">{renderMarkdown(content)}</div>
        </div>
      </div>
    </div>
  );
}
